/* globals mobileNavigation */
$('.an-dropdown-navigationMenu').on('click', 'button[data-toggle="collapse"]', function(event) {
  event.preventDefault();
  event.stopPropagation();
  $($(this).data('target')).collapse('toggle');
});
